import { FC } from 'react';
import { cx } from '@/utils/cx';

export type CardDividerProps = {
  className?: string;
};

export const CardDivider: FC<CardDividerProps> = ({ className }) => (
  <div
    className={cx(
      '-ml-10 -mr-8 mb-6 mt-7 h-px border-b border-gray-900/10',
      className,
    )}
  ></div>
);
